import {FC} from 'react';
import {PersonOutlineOutlined} from '@mui/icons-material';
import {Box} from '@mui/material';
import {FormattedMessage} from 'react-intl';
import {PhoneCardHead} from 'src/components/mobile/PhoneCardHead';
import {PhoneCardFacts} from 'src/components/mobile/PhoneCardFacts';
import {phonePillsRowSx, phoneTitleCellSx} from 'src/components/mobile/mobileDesign.sx';
import {MissingBexioPill} from 'src/components/common/MissingBexioPill';
import {useMissingBexio} from 'src/hooks/useMissingBexio';
import {UserTypeEnum} from 'src/enums';
import {BaseUserInfo} from '../../../types';
import {UserCell} from '../../users/UserCell';
import {TableCard} from '../../tables/respnsiveTable/TableCard';

export const ClientTableCard: FC<BaseUserInfo> = (userItem) => {
    const {chargePointId, userType} = userItem;
    // The warning the cell used to carry in its colour, now said in the card's own words - the cell
    // is worn at the canvas's dark identity weight here, where a blue name would read as a link.
    const showMissingBexio = useMissingBexio({
        hasBexio: !!userItem.bexioDataList?.length,
        userType,
        isCompany: userType === UserTypeEnum.COMPANY,
    });

    return (
        <TableCard>
            {/* The list's own client cell: it carries the tap that opens the person, so the card and
                the row it replaces cannot lead to different pages. */}
            <PhoneCardHead
                person
                icon={<PersonOutlineOutlined/>}
                title={<Box sx={phoneTitleCellSx}><UserCell data={userItem}/></Box>}
            />
            {showMissingBexio && (
                <Box sx={phonePillsRowSx}>
                    <MissingBexioPill/>
                </Box>
            )}
            <PhoneCardFacts
                facts={[
                    {
                        label: <FormattedMessage id="chargePointIdColumnHeader"/>,
                        value: chargePointId || '—',
                    },
                ]}
            />
        </TableCard>
    );
};
